import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import Backdrop from '../cart/backdrop';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers,
  additionalClasses = '',
  showBackdrop = false,
  isOpen,
  setIsOpen,
}) => {
  const {
    openTriggerEl,
    closeTriggerEl,
    openTriggerEl2,
    closeTriggerEl2,
    toggleEl
  } = triggers;
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.body.style.overflow = 'hidden';
    setIsOpen(true);
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.body.style.overflow = '';
    setIsOpen(false);
  };
  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (closeTriggerEl)
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (openTriggerEl2) openTriggerEl2.addEventListener('click', handleOpenEvent);
    if (closeTriggerEl2)
      closeTriggerEl2.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl)
        openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl)
        closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (openTriggerEl2)
        openTriggerEl2.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl2)
        closeTriggerEl2.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [
      openTriggerEl,
      closeTriggerEl,
      openTriggerEl2,
      closeTriggerEl2,
      toggleEl
    ]);

  const closedClass =
    alignment === 'right' ? 'translate-x-full' : '-translate-x-full';

  return (
    <>
      {showBackdrop && <Backdrop isOpen={isOpen} setIsOpen={setIsOpen} />}
      <div
        className={`block
        max-w-md
        w-full h-full
        fixed
        top-0
        bottom-0
        transition-transform
        z-[1100]
        bg-white
        ${alignment === 'right' ? 'right-0' : 'left-0'}
        ${isOpen ? 'translate-x-0' : closedClass}
        ${additionalClasses && additionalClasses}`}
      >
        {children}
      </div>
    </>
  );
};

export default Panel;
